import React, { useCallback } from 'react';

import PersonIcon from '@mui/icons-material/Person';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';

import {
  getSessionStorage,
  setSessionStorage,
} from '../../../Authentication/Actions/authentication';

export default function UserInfo() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { keycloak } = useKeycloak();

  const handleLogOut = useCallback(() => {
    sessionStorage.clear();
    localStorage.clear();
    keycloak.logout({ redirectUri: `${window.location.origin + '/'}` });
    setSessionStorage('loginStatus', 'finished');
  }, []);

  return (
    <>
      <Tooltip title="Account">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <PersonIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem sx={{ backgroundColor: '#efefef' }}>
          {getSessionStorage('user_name') || ''}
        </MenuItem>
        <MenuItem
          onClick={() =>
            keycloak.login({
              action: 'UPDATE_PASSWORD',
            })
          }
        >
          Change Password
        </MenuItem>
        <MenuItem onClick={handleLogOut}>Logout</MenuItem>
      </Menu>
    </>
  );
}
